"use client";
import { setCookie } from "cookies-next/client";
import { useEffect } from "react";
import { UTM_COOKIE_MAX_AGE, UTM_COOKIE_NAME } from "@/constants/utm";
import { useClientConfig } from "@/context/clientConfig";
import { useCreateInformaURL } from "@/hooks/useCreateInformaURL";
import { getUTMParametersFromQuery } from "@/utils/utm/getUTMParametersFromQuery";

export default function SetUTMCookie() {
  const {
    siteConfig: { sitePath },
  } = useClientConfig();

  const { u } = useCreateInformaURL();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const utmParams = getUTMParametersFromQuery(params);

    if (utmParams.length) {
      setCookie(UTM_COOKIE_NAME, JSON.stringify(utmParams), {
        path: sitePath ? u(sitePath) : "/",
        maxAge: UTM_COOKIE_MAX_AGE,
      });
    }
  }, [sitePath, u]);

  return null;
}
